import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgThumbsDownIconSecondary from './svgs/ThumbsDownIconSecondary.js';
import SvgThumbsDownIcon from './svgs/ThumbsDownIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var thumbsDownIcon = (props => useIcon(SvgThumbsDownIcon, SvgThumbsDownIconSecondary, props));

export { thumbsDownIcon as default };
